import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { BrowserRouter, Routes, Route, NavLink } from 'react-router-dom';
import Header from '../inc/header';
import Footer from '../inc/footer';
import { HelmetProvider, Helmet } from 'react-helmet-async';
import { Link } from 'react-router-dom';

function Index() {
    const services = [
        {
            id: "One",
            title: "Interiors",
            items: [
                "Turnkey Projects",
                "Stand Alone and Mall Stores",
                "F&B Outlets – Hot/ Cold Kitchen",
                "Shell and Core Projects",
                "Commercial Office Interiors",
                "Refurbishments",
                "Authority Approvals",
            ],
            img: "/assets/img/slides/Main-Slider-1.png",
            slug: "process-services",
        },
        {
            id: "Two",
            title: "Event",
            items: [
                "Staging",
                "Backdrop",
                "Indoor and Outdoor Arch",
                "LED Screen Cladding",
                "Gallery Walls",
                "Photo Ops",
                "Trophies and Signage",
            ],
            img: "/assets/img/slides/Main-Slider-2.jpg",
            slug: "process-services",
        },
        {
            id: "Three",
            title: "Exhibition",
            items: [
                "Stand Designing",
                "Conceptualization",
                "Pavilions",
                "Mezzanine Stands",
                "Stands with Hanging Canopy",
                "Island Stands",
                "Shell Schemes",
            ],
            img: "/assets/img/slides/Main-Slider-3.jpg",
            slug: "process-services",
        },
        {
            id: "Four",
            title: "Printing",
            items: [
                "Front/Back Lit Banner and Fabric",
                "Mesh Banner & 550gsm Durable Banners",
                "Outdoor Vinyl with UV Lamination",
                "One Way Vision",
                "Day & Night Vinyl (Dual Artwork)",
                "Indoor Vinyl with Lamination",
                "Duratrans and Light Passing Vinyl",
            ],
            img: "/assets/img/slides/Main-Slider-4.jpg",
            slug: "process-services",
        },
        {
            id: "Five",
            title: "Signage",
            items: [
                "Indoor Signage",
                "Outdoor Signage",
                "Warehouse/Building Signage",
                "Roof Top Signage",
                "Hoardings and Billboards",
                "Way Finding Signs",
                "Traffic Signs",
            ],
            img: "/assets/img/slides/Main-Slider-5.jpg",
            slug: "process-services",
        }, 
];
    return (
        <>
         <style type="text/css">
            {` 
                .service-card {
                    background: #fff;
                    border-radius: 14px;
                    overflow: hidden;
                    height: 100%;
                    box-shadow: 0 10px 30px rgba(0, 0, 0, 0.08);
                    transition: all 0.35s ease;
                }

                .service-card:hover {
                    transform: translateY(-8px);
                    box-shadow: 0 20px 45px rgba(0, 0, 0, 0.15);
                }

                /* Image */
                .service-card-img {
                    height: 200px;
                    overflow: hidden;
                }

                .service-card-img img {
                    width: 100%;
                    height: 100%;
                    object-fit: cover;
                    transition: transform 0.4s ease;
                }

                .service-card:hover img {
                    transform: scale(1.08);
                }

                /* Content */
                .service-card-body {
                    padding: 22px;
                }

                .service-title {
                    font-size: 22px;
                    font-weight: 700;
                    margin-bottom: 12px;
                    color: #222;
                }

                /* List */
                .service-list {
                    padding-left: 18px;
                    margin-bottom: 18px;
                }

                .service-list li {
                    font-size: 15px;
                    line-height: 1.7;
                    color: #555;
                }

                /* Button */
                .service-btn {
                    display: inline-block;
                    font-size: 14px;
                    font-weight: 600;
                    color: #000;
                    text-decoration: none;
                    border-bottom: 2px solid #000;
                    padding-bottom: 4px;
                    transition: all 0.3s ease;
                }

                .service-btn:hover {
                    color: #fecd04;
                    border-color: #fecd04;
                }

            `}
        </style>
        <div>
            <Helmet>
                    <title>Radius Exhibition Fixtures &#8211; Interior Fit Out Company in Dubai, UAE | Signage Company - Services</title>
                    <meta name="description" content="Radius Exhibition Fixtures &#8211; Interior Fit Out Company in Dubai, UAE | Signage Company" />
                    <meta property="og:title" content="Radius - Services" />
                    <meta property="og:description" content="Radius Exhibition Fixtures &#8211; Interior Fit Out Company in Dubai, UAE | Signage Company" />
            </Helmet>

            <div className="body text-start">
                
                <Header />
                    <div role="main" className="main">
                        <section
                            className="page-header page-header-modern page-header-background page-header-background-md overlay overlay-color-dark overlay-show overlay-op-7"
                            // style={{
                            //     backgroundImage: "url('/assets/img/slides/page-header-services.jpg')",
                            // }}
                        >
                            <div className="container">
                                <div className="row mt-5">
                                    <div className="col-md-12 align-self-center p-static order-2 text-center">
                                        <h1 className="text-10">
                                            <strong>Services</strong>
                                        </h1>
                                    </div>
                                    <div className="col-md-12 align-self-center order-1">
                                        <ul className="breadcrumb breadcrumb-light d-block text-center">

                                        </ul>
                                    </div>
                                </div>
                            </div>
                        </section>

                        <div className="container pb-1">

                            <div className="row pt-4">
                                <div className="col">
                                    <div className="overflow-hidden mb-3">
                                        <h2 className="font-weight-bold text-8 mb-0" data-appear-animation="maskUp">
                                            We Are Here To Help You
                                        </h2>
                                    </div>
                                </div>
                            </div>

                            <div className="row">
                                <div className="col-lg-10">
                                    <div className="overflow-hidden">
                                        <p className="lead mb-0" data-appear-animation="maskUp" data-appear-animation-delay="200">
                                            We organize memorable events in various sectors including healthcare, technology, finance, energy, engineering… “Original concepts and impeccable execution” is what RADIUS promise.
                                        </p>
                                    </div>
                                </div>
                                <div className="col-lg-2" data-appear-animation="fadeIn" data-appear-animation-delay="500">
                                    <NavLink to="/contact" className="btn btn-modern btn-dark mt-1">Get a Quote !</NavLink>

                                </div>
                            </div>

                            <div className="row">
                                <div className="col py-3">
                                    <hr className="solid mt-5 mb-2" />
                                </div>
                            </div>

                            
                            <div className="row">
                                {services.map((service) => (
                                    <div key={service.id} className="col-md-6 col-lg-4 mb-4">
                                        <div className="service-card">

                                            {/* Image */}
                                            <div className="service-card-img">
                                                <img src={service.img} alt={service.title} />
                                            </div>

                                            {/* Content */}
                                            <div className="service-card-body">
                                                <h3 className="service-title">{service.title}</h3>

                                                <ul className="service-list">
                                                    {service.items.slice(0, 4).map((item, index) => (
                                                        <li key={index}>{item}</li>
                                                    ))}
                                                </ul>

                                                
                                            </div>
                                        </div>
                                    </div>
                                ))}
                            </div>

                        </div>
 

                       
                    </div>
                    

                <div role="main" className="main">
                    <Footer />
                </div>
            
            </div>
        </div>
        </>
    );
}

export default Index;
